<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M9 0C4.03 0 0 4.03 0 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 17.25C4.451 17.25.75 13.549.75 9 .75 4.451 4.451.75 9 .75c4.549 0 8.25 3.701 8.25 8.25 0 4.549-3.701 8.25-8.25 8.25z"
      />
      <path
        :fill="color"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.5 8.625L12.75 5.25 9.375 13.5 8.625 9.375z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
